export default "__VITE_ASSET__B0l3Xd7k__"